import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link Project} add `namespace` field defaulted to `tag:stardog:project:${project.id}`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v5 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v5Projects(prevState.projects);
  }

  return nextState;
};

const v5Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const namespace = `tag:stardog:project:${project.id}:`;
    projectsById[projectId] = {
      ...project,
      // @ts-ignore
      namespace,
    };
  });

  return { ...prevProjectsState, projectsById };
};
